import React, { Component } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import {
    Row,
    FormGroup,
    Col,
    FormControl,
    Container,
    Alert
} from 'react-bootstrap';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import s from './AdvancedNotifications.css';
import bt from '../../../components/commonStyle.css';
import submit from './submit';
import validate from './validate';
import Loader from '../../Common/Loader';
import UserSearchSelect from './UserSearchSelect';
import FilterPanel from './FilterPanel';

export class AdvancedNotificationsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedUsers: [],
            previewCount: 0,
            isLoadingPreview: false,
            filters: {
                userType: 'all', // all, 1 (rider), 2 (driver)
                platform: 'all', // all, android, ios
                activity: {
                    lastLoginDays: null, // active in last X days
                    hasCompletedTrip: null, // true/false/null
                    tripCountMin: null,
                    tripCountMax: null,
                    registeredDays: null, // registered in last X days
                    isOnline: false // currently online (drivers)
                },
                behavior: {
                    hasPaymentMethod: null, // true/false/null
                    minRating: null,
                    maxCancellations: null,
                    isVerified: null // true/false/null (drivers)
                }
            },
            savedSegments: [],
            targetingMode: 'all' // all, filters, specific
        };
    }

    componentDidMount() {
        const { initialize } = this.props;
        initialize({
            title: '',
            targetingMode: 'all'
        });
        this.loadSavedSegments();
    }

    loadSavedSegments = async () => {
        // Load saved segments from API
        try {
            const response = await fetch('http://localhost:4000/get-notification-segments');
            const data = await response.json();
            if (data.status === 200) {
                this.setState({ savedSegments: data.segments || [] });
            }
        } catch (error) {
            console.error('Error loading segments:', error);
        }
    }

    handleTargetingModeChange = (mode) => {
        this.setState({ targetingMode: mode });
        this.props.change('targetingMode', mode);
        if (mode === 'all') {
            this.setState({ previewCount: 'all users' });
        } else {
            this.updatePreviewCount();
        }
    }

    handleFilterChange = (filterType, value) => {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [filterType]: value
            }
        }), () => {
            this.updatePreviewCount();
        });
    }

    handleUserSelection = (users) => {
        this.setState({
            selectedUsers: users,
            previewCount: users.length
        });
    }

    updatePreviewCount = async () => {
        const { targetingMode, filters, selectedUsers } = this.state;

        if (targetingMode === 'specific') {
            this.setState({ previewCount: selectedUsers.length });
            return;
        }

        if (targetingMode === 'filters') {
            this.setState({ isLoadingPreview: true });
            try {
                const response = await fetch('http://localhost:4000/preview-notification-audience', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ filters })
                });
                const data = await response.json();
                if (data.status === 200) {
                    this.setState({ previewCount: data.count });
                }
            } catch (error) {
                console.error('Error getting preview count:', error);
            } finally {
                this.setState({ isLoadingPreview: false });
            }
        }
    }

    saveSegment = async (segmentName) => {
        const { filters } = this.state;
        try {
            const response = await fetch('http://localhost:4000/save-notification-segment', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: segmentName,
                    filters
                })
            });
            const data = await response.json();
            if (data.status === 200) {
                this.loadSavedSegments();
                alert('Segment saved successfully!');
            }
        } catch (error) {
            console.error('Error saving segment:', error);
        }
    }

    loadSegment = (segment) => {
        // Normalize the filters to ensure boolean values are proper booleans
        const normalizedFilters = {
            ...segment.filters,
            activity: {
                ...segment.filters.activity,
                isOnline: !!segment.filters.activity.isOnline
            }
        };

        this.setState({
            filters: normalizedFilters,
            targetingMode: 'filters'
        }, () => {
            this.updatePreviewCount();
        });
        this.props.change('targetingMode', 'filters');
    }

    renderFormControl = ({ input, label, type, meta: { touched, error }, className, maxlength, placeholder }) => {
        const { formatMessage } = this.props.intl;
        return (
            <FormGroup className={s.formGroup}>
                <div>
                    <label className={bt.labelText}>{label}</label>
                </div>
                <div>
                    <FormControl
                        {...input}
                        placeholder={placeholder || label}
                        type={type}
                        className={bt.formControlInput}
                        maxLength={maxlength}
                    />
                    {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
                </div>
            </FormGroup>
        );
    }

    renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
        const { formatMessage } = this.props.intl;
        return (
            <FormGroup className={s.formGroup}>
                <div>
                    <label className={bt.labelText}>{label}</label>
                </div>
                <div className={'textAreaRTL'}>
                    <FormControl
                        {...input}
                        className={className}
                        placeholder={label}
                        as="textarea"
                        rows="3"
                    >
                        {children}
                    </FormControl>
                    {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
                </div>
            </FormGroup>
        );
    }

    handleFormSubmit = (values, dispatch) => {
        const { targetingMode, filters, selectedUsers } = this.state;
        return submit(values, { targetingMode, filters, selectedUsers }, dispatch);
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { handleSubmit, loading, submitting, targetingModeValue } = this.props;
        const {
            selectedUsers,
            previewCount,
            isLoadingPreview,
            filters,
            savedSegments,
            targetingMode
        } = this.state;

        return (
            <div className={'customRatioButton'}>
                <Container fluid>
                    <form onSubmit={handleSubmit(this.handleFormSubmit)}>
                        {/* Targeting Mode Selection */}
                        <Row>
                            <Col xs={12}>
                                <h3 className={s.sectionTitle}>
                                    <FormattedMessage {...messages.targetAudience} />
                                </h3>
                            </Col>
                        </Row>

                        <Row className={s.targetingSection}>
                            <Col xs={12} md={4}>
                                <div
                                    className={cx(s.targetingCard, { [s.active]: targetingMode === 'all' })}
                                    onClick={() => this.handleTargetingModeChange('all')}
                                >
                                    <div className={s.cardIcon}>📢</div>
                                    <h4>All Users</h4>
                                    <p>Send to all riders and drivers</p>
                                </div>
                            </Col>
                            <Col xs={12} md={4}>
                                <div
                                    className={cx(s.targetingCard, { [s.active]: targetingMode === 'filters' })}
                                    onClick={() => this.handleTargetingModeChange('filters')}
                                >
                                    <div className={s.cardIcon}>🎯</div>
                                    <h4>Smart Filters</h4>
                                    <p>Target by role, activity, platform</p>
                                </div>
                            </Col>
                            <Col xs={12} md={4}>
                                <div
                                    className={cx(s.targetingCard, { [s.active]: targetingMode === 'specific' })}
                                    onClick={() => this.handleTargetingModeChange('specific')}
                                >
                                    <div className={s.cardIcon}>👤</div>
                                    <h4>Specific Users</h4>
                                    <p>Search and select individual users</p>
                                </div>
                            </Col>
                        </Row>

                        {/* Saved Segments */}
                        {savedSegments.length > 0 && targetingMode === 'filters' && (
                            <Row className={s.segmentsSection}>
                                <Col xs={12} style={{padding: 0}}>
                                    <h4>Saved Segments</h4>
                                    <div className={s.segmentsList}>
                                        {savedSegments.map(segment => (
                                            <button
                                                key={segment.id}
                                                type="button"
                                                className={s.segmentButton}
                                                onClick={() => this.loadSegment(segment)}
                                            >
                                                <div className={s.segmentName}>{segment.name}</div>
                                                <div className={s.segmentDate}>
                                                    Created: {new Date(segment.createdAt).toLocaleDateString('en-US', {
                                                        month: 'short',
                                                        day: 'numeric',
                                                        year: 'numeric',
                                                        hour: 'numeric',
                                                        minute: '2-digit',
                                                        hour12: true
                                                    })}
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                        )}

                        {/* Smart Filters Panel */}
                        {targetingMode === 'filters' && (
                            <FilterPanel
                                filters={filters}
                                onFilterChange={this.handleFilterChange}
                                onSaveSegment={this.saveSegment}
                            />
                        )}

                        {/* Specific User Selection */}
                        {targetingMode === 'specific' && (
                            <Row>
                                <Col xs={12} lg={8}>
                                    <UserSearchSelect
                                        selectedUsers={selectedUsers}
                                        onUserSelection={this.handleUserSelection}
                                    />
                                </Col>
                            </Row>
                        )}

                        {/* Audience Preview */}
                        <Row className={s.previewSection}>
                            <Col xs={12} md={6}>
                                <Alert variant="info" className={s.previewAlert}>
                                    <div className={s.previewContent}>
                                        <span className={s.previewLabel}>Target Audience:</span>
                                        {isLoadingPreview ? (
                                            <span className={s.previewCount}>Loading...</span>
                                        ) : (
                                            <span className={s.previewCount}>
                                                {typeof previewCount === 'number'
                                                    ? `${previewCount.toLocaleString()} users`
                                                    : previewCount
                                                }
                                            </span>
                                        )}
                                    </div>
                                </Alert>
                            </Col>
                        </Row>

                        {/* Message Content */}
                        <Row>
                            <Col xs={12}>
                                <h3 className={s.sectionTitle}>
                                    <FormattedMessage {...messages.notificationContent} />
                                </h3>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6}>
                                <Field
                                    name="title"
                                    type="text"
                                    component={this.renderFormControl}
                                    label={formatMessage(messages.notificationTitle)}
                                    placeholder="e.g., Special Offer, System Update, New Feature"
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6}>
                                <Field
                                    name="message"
                                    type="text"
                                    component={this.renderFormControlTextArea}
                                    label={formatMessage(messages.msgOnly)}
                                />
                            </Col>
                        </Row>

                        {/* Submit Button */}
                        <Row>
                            <Col xs={12} md={6} className={cx(bt.textAlignRight, 'textAlignLeftRTL')}>
                                <Loader
                                    type="button"
                                    label={formatMessage(messages.sendNotification)}
                                    show={loading}
                                    buttonType="submit"
                                    className={cx(bt.btnPrimary, s.submitButton)}
                                    disabled={submitting || loading || (targetingMode === 'specific' && selectedUsers.length === 0)}
                                    isSuffix={true}
                                />
                            </Col>
                        </Row>
                    </form>
                </Container>
            </div>
        );
    }
}

const selector = formValueSelector('AdvancedNotificationsForm');

AdvancedNotificationsForm = reduxForm({
    form: 'AdvancedNotificationsForm',
    validate
})(AdvancedNotificationsForm);

const mapState = (state) => ({
    loading: state.loader.sendNotification,
    targetingModeValue: selector(state, 'targetingMode')
});

const mapDispatch = {
    change
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AdvancedNotificationsForm)));
